import { useEffect, useState } from 'react';
import { bridge, isNotNil } from '../utils';

export const useFeatureFlagValue = (key: string) => {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const getFlag = () => {
      bridge.getFeatureFlag({ key }).then(result => {
        setFlag(isNotNil(result));
      });
    };

    getFlag();
  }, [key]);

  return flag;
};
